// Jim Halpert — agente do módulo Operacional. Placeholder para a Onda Op-3
// quando o agente for ativado de fato (cron diário, tools próprias).
import { useState } from 'react';

export default function JimConfig() {
  const [aba, setAba] = useState<'sobre' | 'tools' | 'cron'>('sobre');

  return (
    <div style={{ padding: '20px 28px', maxWidth: 900, margin: '0 auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16, gap: 14 }}>
        <span style={{
          width: 40, height: 40, borderRadius: 10, background: '#020D7F',
          color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 18, fontWeight: 700,
        }}>J</span>
        <div>
          <h2 style={{ margin: 0, fontSize: 18, color: '#020D7F' }}>Jim Halpert — agente operacional</h2>
          <div style={{ fontSize: 11, color: '#888' }}>
            Gerente de projetos — coordena execução de contratos
          </div>
        </div>
      </div>

      <div className="tab-bar-h" style={{ display: 'flex', gap: 22, marginBottom: 14, borderBottom: '0.5px solid #e0e0e0' }}>
        {[
          { id: 'sobre', label: 'Sobre' },
          { id: 'tools', label: 'Ferramentas' },
          { id: 'cron', label: 'Cron diário' },
        ].map(t => (
          <button key={t.id} onClick={() => setAba(t.id as any)}
            style={{ fontSize: 13, background: 'none', border: 'none', cursor: 'pointer',
              color: aba === t.id ? '#0930D0' : '#6A7092',
              fontWeight: aba === t.id ? 600 : 400,
              padding: '8px 0', borderBottom: `2px solid ${aba === t.id ? '#0930D0' : 'transparent'}` }}>
            {t.label}
          </button>
        ))}
      </div>

      {aba === 'sobre' && (
        <div style={{ background: '#fff', padding: 20, borderRadius: 6, border: '0.5px solid #e0e0e0' }}>
          <h3 style={{ margin: '0 0 10px', fontSize: 14, color: '#020D7F' }}>Quem é o Jim</h3>
          <p style={{ fontSize: 13, lineHeight: 1.6, color: '#444' }}>
            Jim Halpert é o <strong>gerente de projetos</strong> do módulo Operacional. Cuida da execução
            dos contratos: organiza atividades, cobra prazos, garante que ART e relatórios estejam
            consistentes pra emitir CAT no fim. É o cara que conhece todo mundo, sabe quem está
            atrasado, e monta a minuta de atestado técnico no final.
          </p>
          <p style={{ fontSize: 13, lineHeight: 1.6, color: '#444', marginTop: 12 }}>
            Pam Beesly cuida do <strong>administrativo</strong> em outro módulo (notas fiscais,
            faturamento, ISS, retenções). Os dois trabalham juntos como no Office.
          </p>
          <div style={{ padding: 14, background: '#FFF8E8', border: '0.5px solid #B07500',
            borderRadius: 6, marginTop: 14 }}>
            <strong style={{ color: '#B07500', fontSize: 12 }}>⚠️ Em desenvolvimento (Onda Op-3)</strong>
            <p style={{ fontSize: 12, color: '#664400', margin: '6px 0 0', lineHeight: 1.5 }}>
              Esta tela é placeholder. Na Onda Op-3, o Jim ganha:
            </p>
            <ul style={{ fontSize: 12, color: '#664400', margin: '6px 0 0 18px', lineHeight: 1.6 }}>
              <li>Cron diário 7h BRT — varre contratos e dispara alertas</li>
              <li>Tools próprias: consultar_contratos, gerar_minuta_atestado, etc.</li>
              <li>Notificações Telegram pra responsáveis</li>
              <li>Cross-check ART × contrato × relatórios via Bedrock</li>
            </ul>
          </div>
        </div>
      )}

      {aba === 'tools' && (
        <div style={{ background: '#fff', padding: 20, borderRadius: 6, border: '0.5px solid #e0e0e0' }}>
          <h3 style={{ margin: '0 0 14px', fontSize: 14, color: '#020D7F' }}>Ferramentas planejadas</h3>
          {[
            { nome: 'consultar_contratos', desc: 'Lista contratos com filtros (status, responsável, prazo)' },
            { nome: 'consultar_atividades_contrato', desc: 'Atividades abertas/atrasadas/próximas' },
            { nome: 'consultar_documentos_contrato', desc: 'Drive do contrato por pasta' },
            { nome: 'gerar_minuta_atestado', desc: 'Gera minuta de atestado técnico via Bedrock com cross-check ART × escopo × relatórios' },
            { nome: 'cross_check_atestado', desc: 'Detecta inconsistências antes de enviar ao CREA' },
            { nome: 'atribuir_atividade', desc: 'Atribui responsável a uma atividade' },
            { nome: 'mover_atividade_status', desc: 'Move atividade entre status (kanban)' },
            { nome: 'registrar_lacuna_operacional', desc: 'Registra problemas/oportunidades no backlog' },
          ].map(t => (
            <div key={t.nome} style={{ padding: 10, marginBottom: 6,
              background: '#FAFBFF', borderRadius: 4, border: '0.5px solid #f0f0f0' }}>
              <code style={{ fontSize: 11, color: '#020D7F', fontWeight: 600 }}>{t.nome}</code>
              <div style={{ fontSize: 11, color: '#555', marginTop: 3 }}>{t.desc}</div>
            </div>
          ))}
        </div>
      )}

      {aba === 'cron' && (
        <div style={{ background: '#fff', padding: 20, borderRadius: 6, border: '0.5px solid #e0e0e0' }}>
          <h3 style={{ margin: '0 0 10px', fontSize: 14, color: '#020D7F' }}>Cron diário (7h BRT)</h3>
          <p style={{ fontSize: 12, color: '#555', lineHeight: 1.6 }}>
            Ações automáticas planejadas pra rodar todo dia ao amanhecer:
          </p>
          <ol style={{ fontSize: 12, color: '#444', lineHeight: 1.7, paddingLeft: 22 }}>
            <li>Atividades vencendo em ≤3 dias → notifica responsável (Telegram + e-mail)</li>
            <li>Predecessor concluído + sucessor pendente → muda sucessor pra "em_andamento"</li>
            <li>Contratos sem ART &gt;15 dias após início → alerta gestor</li>
            <li>Documentos esperados não subidos → cria atividade automática</li>
            <li>Contratos com data de término próxima e atestado pendente → sugere gerar minuta</li>
          </ol>
        </div>
      )}
    </div>
  );
}
